export default "/755a2e47023f62f14c04316b94995a2c.jpg";